export default __webpack_public_path__ + "static/media/crimsonsuccor.381911d7.png";